import Image1 from "../../assets/pro.png";
import Image2 from "../../assets/proo2.png";
import Image3 from "../../assets/proo6.png";
import Image4 from "../../assets/proo3.png";
import Image5 from "../../assets/proo1.png";
import Image6 from "../../assets/proo4.png";
import Image7 from "../../assets/proo-7.png";
import Image8 from "../../assets/proo-8.png";
import Image9 from "../../assets/proo-9.png";
import Image10 from "../../assets/proo10.png";

export const projects = [
  {
    id: 1,
    image: Image1,
    name: "E-Commerce App",
    description:
      "A full-stack e-commerce app with user authentication, cart,and checkout functionality + dashboard for admin.",
    technologies: ["Next.js", "Node.js", "MongoDB"],
    githubLink: "https://github.com/Soufiane-Amama",
    liveDemo: "https://my-store-navy.vercel.app/",
  },
    {
    id: 2,
    image: Image7,
    name: "Educational Academy Management Platform",
    description:
      "Modern PWA for children’s academies with QR attendance, PDF reports, and remote monitoring, reduced admin effort by 40%.",
    technologies: ["Next.js", "Node.js", "MongoDB"],
    githubLink: "https://github.com/Soufiane-Amama",
    liveDemo: "https://educational-academy-murex.vercel.app",
  },
    {
    id: 3,
    image: Image8,
    name: "60 Challenge App.AI",
    description:
      "Challenge 60, a 60-day goal-tracking app for youth using generative AI for personalized motivation, smart tips, progress tracking, and shareable visuals.",
    technologies: ["Generative.AI", "Node.js", "MongoDB"],
    githubLink: "https://github.com/Soufiane-Amama",
    liveDemo: "https://sixty-challenge.vercel.app",
  },
    {
    id: 4,
    image: Image9,
    name: "Academy app with live online classes",
    description:
      "A learning platform for Arabic & Quran education. Features user roles, session booking (Live Classes), multilingual support, and responsive design.",
    technologies: ["Next.js", "Node.js", "i18nexus"],
    githubLink: "https://github.com/Soufiane-Amama",
    liveDemo: "https://minimuslimsacademy.com",
  },
  // {
  //   id: 4,
  //   image: Image2,
  //   name: "Portfolio 3D Website",
  //   description:
  //     "A responsive portfolio website to showcase projects and skills.",
  //   technologies: ["Next.js", "Three.js", "Tailwind CSS"],
  //   githubLink: "https://github.com/Soufiane-Amama/my_portfolio_3D",
  //   liveDemo: "https://soufiane-amama-portfolio.vercel.app",
  // },
  {
    id: 5,
    image: Image3,
    name: "Be Green",
    description:
      "An environmental website for organizations or associations that aims to recycle waste in a smart way.",
    technologies: ["React.Js", "Node.js", "MongoDB"],
    githubLink: "https://github.com/Soufiane-Amama/Project-Hackathon_MERN-Stack",
    liveDemo: "https://hackathon-pro-ten.vercel.app",
  },
  {
    id: 6,
    image: Image10,
    name: "Landing Page - DarsaFlow",
    description:
      "A modern landing page designed for Gulf students to promote the DarsaFlow educational app in a smart and engaging way.",
    technologies: ["Next.js", "Chakra-UI", "EmailJS"],
    githubLink: "https://github.com/Soufiane-Amama",
    liveDemo: "https://darsaflow-product.vercel.app",
  },
  // {
  //   id: 6,
  //   image: Image5,
  //   name: "Store website",
  //   description:
  //     "It is an e-commerce simulator where API were used, Several components were dynamically created. it is responsive + features Dark mode and Light mode.",
  //   technologies: ["Next.js", "API", "Tailwind CSS"],
  //   githubLink: "https://github.com/Soufiane-Amama/SifoShop-NextJs-Tailwind",
  //   liveDemo: "https://sifo-shop-next-js-tailwind.vercel.app",
  // },
  // {
  //   id: 7,
  //   image: Image4,
  //   name: "Fitness Tracker App",
  //   description:
  //     "An app to track workouts, calories, and you can add sports exercises in the order you will do them each day.",
  //   technologies: ["React.js", "Node.js", "MongoDB"],
  //   githubLink: "https://github.com/Soufiane-Amama/MERN_Stack_Project",
  //   liveDemo: "https://workout-theta.vercel.app",
  // },
  // {
  //   id: 8,
  //   image: Image6,
  //   name: "Kasper Template",
  //   description:
  //     "The website is a single page. The website is responsive to all screens and displays in a beautiful format and colors.",
  //   technologies: ["HTML", "CSS"],
  //   githubLink: "https://github.com/Soufiane-Amama/Kasper_Template_Two_HTML-CSS",
  //   liveDemo: "https://soufiane-amama.github.io/Kasper_Template_Two_HTML-CSS",
  // },
];
